export const genderOptions = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
  // { label: "Other", value: "Other" },
];

export const civilStatusOptions = [
  { label: "Single", value: "Single" },
  { label: "Married", value: "Married" },
  { label: "Widowed", value: "Widowed" },
  { label: "Separated", value: "Separated" },
  { label: "Divorced", value: "Divorced" },
  { label: "Annulled", value: "Annulled" },
];

export const roleOptions = [
  { label: "Admin", value: "admin" },
  { label: "Staff", value: "staff" },
  { label: "Staff (No System Access)", value: "staff_noaccess" },
  { label: "Guest", value: "guest" },
  { label: "Doctor", value: "doctor" },
  { label: "Patient", value: "patient" },
];

export const statusOptions = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
  { label: "Banned", value: "banned" },
];
